'use strict';

/* Controllers */

angular.module('FlexyBeautyApp.controllers')
    .controller('ForgotPwdCtrl', ['$rootScope', '$scope', '$location', '$window', 'Auth', 'User', '$routeParams', 'Brand',
        function ($rootScope, $scope, $location, $window, Auth, User, $routeParams, Brand) {

            $scope.rememberme = true;
            $scope.processingLogin = false;
            $scope.processingRegister = false;
            $scope.alertsLogin = [];
            $scope.alertsRegister = [];
            $scope.displayErrorMessage = false;
            $scope.brand = Brand;
            $scope.userLogin = {
                email: "",
                password: "",
                confirmPassword: "",
                companyName: "",
                companyModel: "",
                role: Auth.userRoles.user
            }
            if ($routeParams.token && $routeParams.email)//received change pwd request
            {
                $scope.userLogin.email = $routeParams.email
            }

            $scope.login = function () {
                if ($scope.userLogin.email == "" || $scope.userLogin.password == "" || $scope.userLogin.confirmPassword == "") {
                    $scope.addAlertLogin('error', "Merci de renseigner les champs obligatoires");
                    return;
                }
                if ($scope.userLogin.password != $scope.userLogin.confirmPassword) {
                    $scope.addAlertLogin('error', "Le mot de passe et le mot de passe de confirmation ne sont pas identiques");
                    return;
                }
                var user = new User($scope.userLogin);
                $scope.processingLogin = true;
                $scope.alerts = [];
                Auth.loginToProSiteOnForgetPwd(user, $routeParams.token,
                    function (res) {
                        $scope.processingLogin = false;
                        $scope.addAlertLogin('success', "Connexion sécurisée établie");
                        $location.path('/');
                    },
                    function (errorMessage) {
                        $scope.addAlertLogin('error', errorMessage);
                        $scope.processingLogin = false;
                    });
            };

            $scope.addAlertLogin = function (type, msg) {
                $scope.alertsLogin.push({type: type, msg: msg});
            };

            $scope.closeAlertLogin = function (index) {
                $scope.alertsLogin.splice(index, 1);
            };

        }
    ]);





// WEBPACK FOOTER //
// ./js/controllers/pro/ForgotPwdCtrl.js